import { useEffect, useState } from 'react';
import '../css/manageuser.css';
import Header from '../components/header';
import User from '../components/user';
import { fetchUsers } from '../Utility/Users/manageUsersFunctions';

function ManageUser() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 

    // Effettua la richiesta al backend
    useEffect(() => {
        fetchUsers(setUsers, setError, setLoading);
    }, []);

    
    return (
        <>
            <Header />
            <div className="riga">
                <h3 className="titolo titoloManage">MANAGE USER</h3>
                <span className="description text">
                </span>
                <div className="space"></div>
            </div>
            <div className="riga space-bottom">
                {loading ? (
                    <p>Loading...</p> // Mostra un messaggio di caricamento
                ) : error ? (
                    <p className="error">{error}</p> // Mostra l'errore se c'�
                ) : (
                    users.map((user) => (
                        <div key={user._id}>
                            <User
                                email={user.email}
                                name={user.firstname}
                                surname={user.lastname}
                                company={user.company}
                            />
                        </div>
                    ))
                )}
                <div className="space"></div>
            </div>
        </>
    );
}

export default ManageUser;
